import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromCommonStore from './common-store.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CommonStoreEffects } from './common-store.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromCommonStore.commonStoreFeatureKey, fromCommonStore.reducer),
    EffectsModule.forFeature([CommonStoreEffects])
  ]
})
export class CommonStoreModule { }
